"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const types_1 = require("../../types");
const drippingFormUtil_1 = __importDefault(require("../../utils/drippingFormUtil"));
class StoreValidation {
    constructor(fields) {
        this.fields = fields;
    }
    isValid() {
        if (!this.HasBlankRequiredFields() && this.IsReleaseOrExpirationEnabled()) {
            const isReleaseFieldValid = this.IsReleaseFieldValid();
            const isExpirationFieldValid = this.IsExpirationFieldValid();
            const isClassTypeValid = this.HasClassTypeValidValues();
            return isReleaseFieldValid && isExpirationFieldValid && isClassTypeValid;
        }
        return false;
    }
    IsReleaseFieldValid() {
        return (!this.fields.isReleaseEnabled ||
            (this.fields.isReleaseEnabled && this.HasReleaseValidValues()));
    }
    IsExpirationFieldValid() {
        return (!this.fields.isExpirationEnabled ||
            (this.fields.isExpirationEnabled && this.HasExpirationFieldValidValues()));
    }
    HasReleaseValidValues() {
        const isReleaseNumberOfDaysValid = this.fields.releaseDrippingType === types_1.ReleaseDrippingTypes.DaysAfter &&
            this.fields.releaseNumberOfDays !== constants_1.INITIAL_FIELDS.numberOfDays &&
            drippingFormUtil_1.default.isNumberOfDaysValid(this.fields.releaseNumberOfDays);
        const isReleaseDateTimeISOValid = this.fields.releaseDrippingType === types_1.ReleaseDrippingTypes.SpecificDate &&
            this.fields.releaseDateTimeISO !== constants_1.INITIAL_FIELDS.releaseDateTimeISO;
        const isQuizValid = this.fields.releaseDrippingType === types_1.ReleaseDrippingTypes.Quiz &&
            Boolean(this.fields.quizId);
        return (isReleaseNumberOfDaysValid || isReleaseDateTimeISOValid || isQuizValid);
    }
    HasExpirationFieldValidValues() {
        return (this.fields.expirationNumberOfDays !== constants_1.INITIAL_FIELDS.numberOfDays &&
            drippingFormUtil_1.default.isNumberOfDaysValid(this.fields.expirationNumberOfDays));
    }
    HasClassTypeValidValues() {
        return (this.fields.classType === types_1.ClassTypes.All ||
            (this.fields.classType === types_1.ClassTypes.Specific &&
                this.fields.selectedClasses.length > 0));
    }
    HasBlankRequiredFields() {
        const hasBlankReleaseRequiredFields = this.HasBlankReleaseRequiredFields();
        const hasBlankExpirationRequiredFields = this.fields.isExpirationEnabled &&
            this.fields.expirationNumberOfDays === constants_1.INITIAL_FIELDS.numberOfDays;
        const hasBlankClassTypeRequiredFields = this.fields.classType === constants_1.INITIAL_FIELDS.classType ||
            (this.fields.classType === types_1.ClassTypes.Specific &&
                this.fields.selectedClasses.length === 0);
        return (hasBlankReleaseRequiredFields ||
            hasBlankExpirationRequiredFields ||
            hasBlankClassTypeRequiredFields);
    }
    isReleaseDrippingTypeBlank() {
        return (this.fields.releaseDrippingType === constants_1.INITIAL_FIELDS.releaseDrippingType);
    }
    isReleaseNumberOfDaysBlank() {
        return (this.fields.releaseDrippingType === types_1.ReleaseDrippingTypes.DaysAfter &&
            this.fields.releaseNumberOfDays === constants_1.INITIAL_FIELDS.numberOfDays);
    }
    isReleaseDateTimeISOBlank() {
        return (this.fields.releaseDrippingType === types_1.ReleaseDrippingTypes.SpecificDate &&
            this.fields.releaseDateTimeISO === constants_1.INITIAL_FIELDS.releaseDateTimeISO);
    }
    isQuizBlank() {
        return (this.fields.releaseDrippingType === types_1.ReleaseDrippingTypes.Quiz &&
            !this.fields.quizId);
    }
    HasBlankReleaseRequiredFields() {
        return (this.fields.isReleaseEnabled &&
            (this.isReleaseDrippingTypeBlank() ||
                this.isReleaseNumberOfDaysBlank() ||
                this.isReleaseDateTimeISOBlank() ||
                this.isQuizBlank()));
    }
    IsReleaseOrExpirationEnabled() {
        return this.fields.isReleaseEnabled || this.fields.isExpirationEnabled;
    }
}
exports.default = StoreValidation;
